import {handleActions} from 'redux-actions'
import {supportFormMode, supportPopupPositionStrategy} from './constants'
import * as ActionTypes from './actionTypes'

const createSupportReducer = ({
    SUPPORT = null
}) => {
    const popupInfo = {
        isShown: false,
        mode: supportFormMode.EDITOR,
        text: '',
        attachmentId: 0,
        attachmentName: '',
        email: '',
        position: {
            x: null,
            y: null,
        },
        positionStrategy: supportPopupPositionStrategy.FROM_TOP_LEFT,
        ...SUPPORT.POPUP_INFO,
    }

    const initialState = {
        showSupportQuestionButton: SUPPORT.showSupportQuestionButton,
        loading: false,
        ...popupInfo,
    }

    return handleActions({
        [ActionTypes.SUPPORT_FORM_OPEN]: (state) => ({
            ...state,
            isShown: true,
        }),
        [ActionTypes.SUPPORT_FORM_CLOSE]: (state) => ({
            ...state,
            isShown: false,
            mode: supportFormMode.EDITOR,
            position: {
                x: null,
                y: null,
            },
            positionStrategy: supportPopupPositionStrategy.FROM_TOP_LEFT,
        }),
        [ActionTypes.LOADING_START]: (state) => ({
            ...state,
            loading: true,
        }),
        [ActionTypes.LOADING_STOP]: (state) => ({
            ...state,
            loading: false,
        }),
        [ActionTypes.SUPPORT_FORM_POSITION_SET]: (state, {payload: positionParams}) => ({
            ...state,
            positionStrategy: positionParams.positionStrategy,
            position: positionParams.position,
        }),
        [ActionTypes.SUPPORT_FORM_MODE_SET]: (state, {payload: mode}) => ({
            ...state,
            mode
        }),
        [ActionTypes.SUPPORT_FORM_TEXT_SET]: (state, {payload: text}) => ({
            ...state,
            text
        }),
        [ActionTypes.SUPPORT_FORM_ATTACHMENT_ID_SET]: (state, {payload: attachmentId}) => ({
            ...state,
            attachmentId
        }),
        [ActionTypes.SUPPORT_FORM_ATTACHMENT_NAME_SET]: (state, {payload: attachmentName}) => ({
            ...state,
            attachmentName
        }),
        [ActionTypes.SUPPORT_FORM_EMAIL_SET]: (state, {payload: email}) => ({
            ...state,
            email
        }),
        [ActionTypes.SUPPORT_FORM_RESET]: (state) => ({
            ...state,
            loading: false,
            text: '',
            attachmentId: 0,
            attachmentName: '',
            email: '',
        }),
    }, initialState)
}

export default createSupportReducer



// WEBPACK FOOTER //
// ./web/js/support/supportForm/reducer.js